export default __webpack_public_path__ + "static/media/estado-16.ca8a79db.svg";